import styled from "styled-components";

export const SelectTitle = styled.div`
  padding: 0px 8px 5px 0;
  font-family: 'Montserrat Medium';
  color: var(--grey-95);
`;
